import React, { useState } from 'react';
import { useCSHMessage } from "./useCSHMessage";
import { postJwt } from '../../helpers/clearnet_api_helper';
import { Input } from "reactstrap";

const CSHAuth = ({ onAuthenticated }) => {
    const [email, setEmail] = useState('');
    const [showMessage, message] = useCSHMessage();
    const [loading, setLoading] = useState(false);
    const [helpMessage, setHelpMessage] = useState('');
    const [isHelpMode, setIsHelpMode] = useState(false);


    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        try {

            if (isHelpMode) {
                await postJwt(process.env.REACT_APP_CSHUB_API_URL_HELP, { email, message: helpMessage });
                await showMessage({ message: 'Your message has been sent. We will contact you soon.', messageType: "success" });

                // reset form
                setEmail('');
                setHelpMessage('');
                setIsHelpMode(false);
                return;
            }

            // Call the API to authenticate and get JWT token
            const { token } = await postJwt(process.env.REACT_APP_CSHUB_API_URL_AUTHENTICATE, { email });

            if (!token || token === '') {
                throw new Error('Login Failed: User not found');
            }

            // const { token } = await res.json();
            localStorage.setItem('csh_jwt_token', token);
            // Decode JWT to get the role
            //const payload = JSON.parse(atob(token.split('.')[1]));
            //const role = payload.role || 'user';

            // Notify parent that auth succeeded — no navigation needed
            onAuthenticated();

        } catch (err) {
            await showMessage({ message: (err?.message || 'Unknown error'), messageType: "danger" });
        } finally {
            setLoading(false);
        }
    };

    return (
        <div
            style={{
                position: 'relative',
                height: '100%',
                width: '100%',
                minHeight: 300,
                cursor: loading ? 'progress' : 'default'
            }}
        >
            {message}
            <div style={{
                position: 'absolute',
                top: '40%',
                left: '50%',
                transform: 'translate(-50%, -50%)',
                width: 300,
            }}>
                <form onSubmit={handleSubmit}>
                    <h2 style={{ fontFamily: 'Bahnschrift, sans-serif', marginBottom: '20px', fontWeight: 700, textAlign: 'center' }}>
                        ClearStone Hub
                    </h2>

                    {isHelpMode ? (
                        <h4>Contact Us</h4>
                    ) : (
                        <h4>Sign In</h4>
                    )}

                    <input
                        type="email"
                        value={email}
                        onChange={e => setEmail(e.target.value)}
                        placeholder="Enter your email"
                        required
                        style={{ width: '100%', border: '1px solid #888', marginBottom: 10, height: 30 }}
                    />

                    {isHelpMode ? (
                        <>
                            <Input
                                type="textarea"
                                value={helpMessage}
                                onChange={e => setHelpMessage(e.target.value)}
                                placeholder="Enter your message for help"
                                required
                                rows={5}
                                style={{ width: '100%', border: '1px solid #888', marginBottom: 10 }}
                            />
                            <button
                                type="submit"
                                style={{
                                    width: '100%',
                                    cursor: loading ? 'progress' : 'pointer'
                                }}
                                disabled={loading}
                            >
                                Submit
                            </button>
                            <button                                
                                style={{
                                    marginTop: 10,
                                    width: '100%',
                                    cursor: loading ? 'progress' : 'pointer'
                                }}
                                onClick={() => { setEmail(''); setHelpMessage(''); setIsHelpMode(false); }}
                            >
                                Back to Login
                            </button>
                        </>
                    ) : (
                        <>
                            <button
                                type="submit"
                                style={{
                                    width: '100%',
                                    cursor: loading ? 'progress' : 'pointer'
                                }}
                                disabled={loading}
                            >
                                Login
                            </button>
                            <div style={{ marginTop: 20, fontSize: 14, color: '#666' }}>
                                Trouble logging in? Contact us for
                                <span
                                    style={{
                                        minWidth: 100,
                                        marginLeft: 8,
                                        fontWeight: 'normal',
                                        color: '#556ee6',
                                        cursor: 'pointer',
                                    }}
                                    onClick={() => setIsHelpMode(true)}
                                    title="Go to Help"
                                >
                                    <strong>Help</strong>
                                </span>
                            </div>
                        </>
                    )}
                </form>
            </div>
        </div>
    );
};

export default CSHAuth;